<div class="flex flex-col pb-2">
  @if (actions().length > 0) {
    <div class="px-6 pt-2 pb-1 text-xs/[18px] font-bold">AI Actions:</div>
    @for (action of actions(); track action.id) {
      <flx-ai-command
        [title]="action.title"
        [icon]="action.icon"
        [shortcut]="action.shortcut"
        [disabled]="action.disabled"
        [tooltip]="action.tooltip"
        (action)="action.action()"
      />
    }
  }
  @if (commands()?.length) {
    <div class="px-6 pt-2 pb-1 text-xs/[18px] font-bold">Suggestions:</div>
    @for (command of commands(); track command.id) {
      <flx-ai-command
        [title]="command.title"
        [icon]="command.icon"
        [shortcut]="command.shortcut"
        [disabled]="command.disabled"
        [tooltip]="command.tooltip"
        [highlighted]="highlight() === command.id"
        (action)="command.action()"
      />
    }
  }
</div>
